var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSuccessTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.99951 0C4.49951 0 -0.000488281 4.5 -0.000488281 10C-0.000488281 15.5 4.49951 20 9.99951 20C15.4995 20 19.9995 15.5 19.9995 10C19.9995 4.5 15.4995 0 9.99951 0ZM9.99951 18C5.58951 18 1.99951 14.41 1.99951 10C1.99951 5.59 5.58951 2 9.99951 2C14.4095 2 17.9995 5.59 17.9995 10C17.9995 14.41 14.4095 18 9.99951 18ZM14.5895 5.58L7.99951 12.17L5.40951 9.59L3.99951 11L7.99951 15L15.9995 7L14.5895 5.58Z",
    fill: "#0CD619"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessTick);
export default __webpack_public_path__ + "static/media/successTick.62ca251de908fb9a66711a28de02bda7.svg";
export { ForwardRef as ReactComponent };